module.exports = __webpack_public_path__ + "static/Fadi_track(x)-35f9129aa55d912814dce1e445f94e4f.mp3";